import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import Button from '../../../core/form/Button';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import Card from '../../../core/layout/Card';
import VocabularyFormContainer from './VocabularyFormContainer';

const VocabularyFormScene = (props) => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: `${props.params.vocabularyId ? 'Edit Vocabulary' : 'Create Vocabulary'}`,
        },
      ]}
    />
    <Card
      title={props.params.vocabularyId ? 'Edit Vocabulary' : 'Create Vocabulary'}
      actions={<Button icon="arrow-left" label="Back" type="default" onClick={() => browserHistory.goBack()} />}
    >
      <VocabularyFormContainer vocabularyId={props.params.vocabularyId} />
    </Card>
  </div>
);

VocabularyFormScene.propTypes = {
  params: PropTypes.shape({
    vocabularyId: PropTypes.string,
  }),
};

VocabularyFormScene.defaultProps = {
  params: null,
};

export default VocabularyFormScene;
